module.exports = __webpack_public_path__ + "img/pic-pay-code@3x.20c82191.png";